import { REGEX_PARTS_DATE } from './constants';
import { FORMAT_PATTERNS } from './formatLabel';

const { MM, DD, YYYY, MMM, MMMM, SEP } = REGEX_PARTS_DATE;

export type FormatPatternType = typeof FORMAT_PATTERNS[keyof typeof FORMAT_PATTERNS];

const {
  MM_DD_YYYY,
  DD_MM_YYYY,
  MM_YYYY,
  MMM_DD_YYYY_COMMA,
  MMM_DD_YYYY,
  DD_MMM_YYYY,
  DD_MMM_YYYY_COMMA,
  MMM_YYYY,
  MMMM_DD_YYYY,
  MMMM_DD_YYYY_COMMA,
  DD_MMMM_YYYY,
  DD_MMMM_YYYY_COMMA,
  MMMM_YYYY,
  YYYY_MM_DD,
} = FORMAT_PATTERNS;
export type DateFormatType = {
  regex: RegExp;
  label: FormatPatternType;
};

const LEFT_BOUNDARY = '(^|\\s|[^a-zA-Z0-9])'; // start of string or non-word character
const RIGHT_BOUNDARY = '(?=$|\\s|[^a-zA-Z0-9])'; // lookahead for end of string or non-word
const pattern = (expression: string) => new RegExp(`${LEFT_BOUNDARY}${expression}${RIGHT_BOUNDARY}`, 'i');

const dateFormatPatterns: [FormatPatternType, string][] = [
  // Numeric formats
  [MM_DD_YYYY, `${MM}${SEP}${DD}${SEP}${YYYY}`],
  [DD_MM_YYYY, `${DD}${SEP}${MM}${SEP}${YYYY}`],
  [MM_YYYY, `${MM}${SEP}${YYYY}`],

  // Short month formats
  [MMM_DD_YYYY_COMMA, `${MMM} ${DD}, ${YYYY}`],
  [MMM_DD_YYYY, `${MMM} ${DD} ${YYYY}`],
  [DD_MMM_YYYY, `${DD}${SEP}${MMM}${SEP}${YYYY}`],
  [DD_MMM_YYYY_COMMA, `${DD} ${MMM}, ${YYYY}`],
  [MMM_YYYY, `${MMM} ${YYYY}`],

  // Full month formats
  [MMMM_DD_YYYY, `${MMMM}${SEP}${DD}${SEP}${YYYY}`],
  [MMMM_DD_YYYY_COMMA, `${MMMM} ${DD}, ${YYYY}`],
  [DD_MMMM_YYYY, `${DD}${SEP}${MMMM}${SEP}${YYYY}`],
  [DD_MMMM_YYYY_COMMA, `${DD} ${MMMM}, ${YYYY}`],
  [MMMM_YYYY, `${MMMM}${SEP}${YYYY}`],
  [YYYY_MM_DD, `${YYYY}${SEP}${MM}${SEP}${DD}`],
];

export const DATE_FORMATS: Record<string, DateFormatType> = Object.fromEntries(
  dateFormatPatterns.map(([label, regexStr]) => [
    label,
    {
      regex: pattern(regexStr),
      label,
    },
  ]),
);
